export default __webpack_public_path__ + "static/media/p6.29a2af8e.jpeg";